import { message as $message } from 'antd'
import { fetchOrderNumApi } from '@/services/order'
import { getToken } from '@/utils/token'

// channel容器下，非渠道侧路由必须在此处记录
const staticRoutes = [
    {
        activityType: 'sample',
        menuName: '采购车'
    },
    {
        activityType: 'order',
        menuName: '订单'
    },
    {
        activityType: 'my',
        menuName: '我的'
    },
    {
        activityType: 'groupManifestDetail',
        menuName: '盘货表详情'
    }
]

const TAB_MENU = [
    {
        activityType: 'businessDynamics',
        channelId: '/channel/my/businessDynamics',
        fullPath: '/channel/my/businessDynamics',
        menuName: '首页'
    },
    {
        activityType: 'myGoods',
        channelId: '/channel/my/myGoods',
        fullPath: '/channel/my/myGoods/alreadyReleaseGoods',
        menuName: '商品'
    },
    {
        activityType: '/channel/my/orders',
        channelId: '/channel/my/orders',
        fullPath: '/channel/my/distributionErpOrder',
        menuName: '订单'
    },
    {
        activityType: '/channel/my/dataCenter/salesDashboard',
        channelId: '/channel/my/dataCenter/salesDashboard',
        fullPath: '/channel/my/dataCenter/salesDashboard',
        menuName: '数据中心'
    },
    {
        activityType: 'myGroupManifest',
        channelId: '/channel/my/myGroupManifest',
        fullPath: '/channel/my/myGroupManifest',
        menuName: '盘货表'
    }
]

const NavModel = {
    namespace: 'nav',
    state: {
        data: [],
        current: undefined,
        selected: null,
        loaded: false
    },
    effects: {
        *query({ payload }, { call, put }) {
            try {
                const data = TAB_MENU

                let current

                if (payload && payload.activityType) {
                    current = payload.activityType
                } else {
                    current = data[0] && data[0].activityType
                }

                yield put({
                    type: 'update',
                    payload: {
                        data,
                        current,
                        loaded: true
                    }
                })

                if (getToken()) {
                    const res = yield call(fetchOrderNumApi)
                    if (res.success) {
                        if (res.data) {
                            const { waitConfirm = 0, waitOuterSent = 0, question = 0 } = res.data
                            data.find(item => item.activityType === '/channel/my/orders').num =
                                waitConfirm + waitOuterSent + question
                            yield put({
                                type: 'update',
                                payload: {
                                    data,
                                    current,
                                    loaded: true
                                }
                            })
                            return res.data
                        }
                    } else {
                        $message.error(res.message)
                    }
                }
            } catch (e) {
                console.error('catchError', e)
            }
        }
    },
    reducers: {
        update(state, { payload }) {
            const next = {
                ...state,
                ...payload
            }

            return {
                ...next,
                selected:
                    next.data.find(v => v.channelId === next.current) ||
                    staticRoutes.find(v => v.channelId === next.channelId)
            }
        }
    }
}

export default NavModel
